// extracted by mini-css-extract-plugin
export default {"container":"User__container--xvRhP","content":"User__content--OgWzz","description":"User__description--30RtP"};